// Add to context is a context mechanism used for clean and tidy code
//, that is managable in later application states.
// This can be extended to create a more complex context mechanism
// This can be extended to create no-reload websites
// This can be extended to create vanilla JavaScript web applications
import isDragging from "./isDragging";

export default function IntlyPaddle(el) {
    const lib = {
        qsa: (sel, el = document) => {
            if(!sel) {
                console.error('Query Selector Not Found: ' + sel);
                return [];
            }
            return el.querySelectorAll(sel) ?? [];
        },
        qs: (sel, el = document) => {
            if(!sel) {
                console.error('Query Selector Not Found: ' + sel);
                return null;
            }
            return el.querySelector(sel) ?? null;
        }
    }

   // Loop through each paddle slider
   el.target.forEach(paddleSlider => {
        // Initialise Paddle Sliders
        const container = lib.qs('.--scrollable', paddleSlider);
        const slider = lib.qs('.paddle', paddleSlider);
        const leftPaddle = paddleSlider.querySelector('.--paddle-left');
        const rightPaddle = paddleSlider.querySelector('.--paddle-right');
        const items = lib.qsa('.--card', slider);
        container.style.userSelect = 'none';

        // Get total element width
        const element = items[1];
        const styles = window.getComputedStyle(element);
        const width = element.getBoundingClientRect().width;
        const marginLeft = parseFloat(styles.marginLeft);
        const marginRight = parseFloat(styles.marginRight);
        const smallWidth = width + marginLeft + marginRight;
        // End get total element width

        

        let isDown = false;
        let isAnimating = false;
        let startX, scrollLeft;
        let activeItem = 0;

        // Build Array of Snap Points
        const getSnapPoints = () => {
            let itemWidth = smallWidth;
            let numElements = Math.floor(items.length + 1);
            let itemWidths = Array(numElements).fill(itemWidth);

            itemWidths = itemWidths.map((item, index) => {
                return (item * (index));
            });

            return itemWidths;
        }



        const renderMethod = (index = null) => {

            // Index Update
            if(index) {
                console.log('index updated');
                activeItem = index;
            }
            
            isAnimating = true;

            (activeItem <= 0) ? leftPaddle.classList.add('is-disabled') : leftPaddle.classList.remove('is-disabled');
            (activeItem >= items.length - 1) ? rightPaddle.classList.add('is-disabled') : rightPaddle.classList.remove('is-disabled');

            if(activeItem < 0) {
                activeItem = 0;
                return;
            }

            if(activeItem >= items.length) {
                activeItem = items.length - 1;
                return;
            }

            setTimeout(() => {
                isAnimating = false;
              
                slider.scrollTo({
                    left: getSnapPoints()[activeItem],
                    behavior: 'smooth'
                });

                transferable();
            }, 300);
            
            items.forEach((item, index) => {
                if (index === activeItem) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        }

        setInterval(() => {
            isAnimating = false;
        }, 1000);


        // Standard Paddle 'Left' and 'Right' behaviour
        const paddles = {
            left: () => leftPaddle?.addEventListener('click', () => {

                if(isAnimating) return;
                if(activeItem < 1) return;
                activeItem = activeItem - 1;
                const currentScroll = slider.scrollLeft;
                // const newScroll = currentScroll - (window.innerWidth / 3) + 8;
                const newScroll = currentScroll - (412 + 46);
                slider.scrollTo({ left: newScroll, behavior: 'smooth' });
                
                renderMethod();
            }),
            right: () => rightPaddle?.addEventListener('click', () => {
                if(isAnimating) return;
                if(activeItem + 1 >= items.length) return;
                activeItem = activeItem + 1;
                const currentScroll = slider.scrollLeft;
                //const newScroll = currentScroll + (window.innerWidth / 3) + 8;
                const newScroll = currentScroll + (412 + 46);
                slider.scrollTo({ left: newScroll, behavior: 'smooth' });
                renderMethod();
            })
        }

        paddles.left();
        paddles.right();

        // Draggable behaviour
        const draggable = {
            drag: () => {
                container.querySelectorAll('img').forEach(img => {
                    img.setAttribute('draggable', 'false');
                });
        
                container.addEventListener('mousedown', (e) => {
                    isDown = true;
                    container.classList.add('active');
                    startX = e.pageX - slider.offsetLeft;
                    scrollLeft = slider.scrollLeft;
                    console.error('mousedown');
                });
        
                container.addEventListener('mouseleave', () => {
                    isDown = false;
                    container.classList.remove('active');
                    
                });
            
                container.addEventListener('mouseup', () => {
                    isDown = false;
                    container.classList.remove('active');
                    draggableState();
                });
        
                container.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - slider.offsetLeft;
                    const walk = (x - startX) * 2; // Controls Speed
                    slider.scrollLeft = scrollLeft - walk;
                });

                // Draggable State (Open Items if Snap Points)
                const draggableState = () => {
                    getSnapPoints().forEach((item, index) => {
                        if(slider.scrollLeft >= (item) && slider.scrollLeft < (item + smallWidth)) {
                            activeItem = index;
                            renderMethod();
                        }
                    });
                }
            }
        }

        draggable.drag();
        

        // transferable
        // Addon to transfer Content on Active Slide
        const transferable = () => {
            
            let items = lib.qsa('.--card', slider);
            let selected = items[activeItem];
            let select = paddleSlider.closest('.container')?.querySelector('.--transferable');

            if (!select) {
                console.error('No Transfer Common Parent Found');
                return;
            }
        
            if(!selected.querySelector('.--transfer')) { console.error('No Transfer Content Found'); return; }
            if(!select) { console.error('No Transfer Recepient Found'); return; }

            select.innerHTML = selected.querySelector('.--transfer').innerHTML;
        }
        // END Addon to transfer Content on Active Slide
        // TRANSFERRABLE

        transferable();


        const clickable = () => {
            let items = lib.qsa('.--card', slider);

            items.forEach((item, index) => {
                isDragging(item, (clicked) => {
                    if(clicked) {
                        setTimeout(() => {
                            renderMethod(index);
                        }, 300);
                    }

                    if(!clicked) {
        
                    }
                });
            });
        }

        clickable();
   });
};
/* End Paddle Slider */

